import { Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, InputLabel, makeStyles, Menu, MenuItem, Select, TextField } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RemoveIcon from '@material-ui/icons/Remove';
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { format } from "date-fns";
import { useFormik } from "formik";
import { boiDepartmentId, cancelServiceId, M24_CONFIG_DOC, RequestDocStatus, RoleId, STATUS_PROCESS } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError, sortByName } from "libs/utils/form";
import { get } from "lodash";
import mime from "mime";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  approveDoc, boiapproveex, clearConsults, consultDoc, docLogs,
  forceApprove, otherApproveDoc, otherUndo, reassignDoc,
  rejectDoc,
  requestDocuments, staffBOIApprove, superaccessList, superaccessremove, undoDoc
} from "redux/modules/allDocumentsSlice";
import { selectIsBOI, selectIsOtherDepartment } from "redux/modules/authSlice";
import { getEmployeeList } from "redux/modules/employeeSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { getDocumentrequiredbydraftid } from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import ConfigSmartServiceService from "services/ConfigSmartServiceService";
import ReportService from "services/ReportService";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  buttonInfo: {
    width: "100px", height: "40px", marginLeft: "15px", fontSize: "12px"
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
    marginLeft: "15px",
    cursor: 'pointer'
  },
  warpDialog: {

    padding: "30px", minWidth: "600px", minHeight: "200px"
  },
  dtitle: {
    color: '#40B8D4',
  },
  warpRowDialog: {
    marginTop: 10
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10
  },
  d2title: {
    color: '#172B4D',
    paddingBottom: 10

  },
  textDialog: {
    width: '100%',
  },
  warpButtonDialogSave: {
    display: 'flex'
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  rowMenuPopOver: {
    padding: 15,
    paddingTop: 0
  },
  rowPopTitle: {
    paddingBottom: "15px", borderBottom: "1px solid lightgray", fontWeight: "500", color: "#101A5F", textAlign: 'center',
    marginBottom: 15
  },
  rowPopItem: {
    padding: 5,
    fontWeight: "500",
    color: "#101A5F",
    display: 'flex',
    justifyContent: 'flex-start'
  },
  iconPop: {
    color: "white", fontWeight: "bold", marginRight: "10px", borderRadius: "50%", verticalAlign: "middle", width: "25px", height: "25px"
  },
  wrapField: {
    marginTop: 15
  },
  formControl: {
    width: '100%'
  },
  wrapRequestDoc: {
    marginBottom: 10
  },
  textField: {
    width: '100%'
  },
  wrapRequestDocPending: {
    fontSize: "16px", color: "#feb969"
  },
  superremove: {
    color: 'orangered',
    cursor: 'pointer'
  },
  superwrapSupervisorList: {
    display: "flex", borderBottom: "1px solid rgba(0, 0, 0, 0.12)", padding: "10px 5px", justifyContent: "space-between"
  }
}))

export default function AdminButtonController({
  hideSaveDraft = false,
  isDisabledNextButton = false,
  isExtend = false,
  nextButtonText = "Next",
  onClickSaveDraft = () => { },
  onClickNext = () => { },
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { showLoading, hideLoading } = useModalLoading();
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  const { role } = useSelector((state) => state.auth);
  const { draftId: draftIdSelected, staffID, statusProcessId, statusDocId } = useSelector(
    (state) => state.allDocuments?.detail
  );

  const { consults } = useSelector(
    (state) => state.allDocuments
  );

  const { profile } = useSelector(
    (state) => state.user
  );
  const [open, setOpen] = React.useState(false);


  const [openStaffApprove, setOpenStaffApprove] = React.useState(false);
  const [openSupervisor, setOpenSupervisor] = React.useState(false);
  const [openDepApprove, setOpenDepApprove] = React.useState(false);
  const [openDepAssign, setOpenDepAssign] = React.useState(false);
  const [openReqLogs, setOpenReqLogs] = React.useState(false);
  const [openReqDocs, setOpenReqDocs] = React.useState(false);
  const [empRoleSelected, setEmpRoleSelected] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isBOI = useSelector(selectIsBOI);
  const isOther = useSelector(selectIsOtherDepartment);
  const { configApprveSmartFrom } = useSelector(
    (state) => state.allDocuments.detail
  );

  const { detail: docDetail } = useSelector(
    (state) => state.allDocuments
  );

  useEffect(async () => {
    const body = {
      departmentId: profile.departmentId
    }
    await dispatch(getEmployeeList(body));

  }, []);


  useEffect(async () => {

    if (draftIdSelected) {
      const bodyC = {
        draftId: draftIdSelected
      };
      await dispatch(superaccessList(bodyC))
      await dispatch(getDocumentrequiredbydraftid({ draftId: draftIdSelected }))

    }

  }, [draftIdSelected]);


  const boiApproveDoc = async () => {


    if (docDetail?.smartserviceId === cancelServiceId ||
      docDetail?.visaRequestID === "f4e46279-2f64-4428-a7ea-9062b9baf334") {

      if (!window.confirm(`Do you want to approve this document?`)) return

      showAdminLoading();
      const body = {
        draftId: draftIdSelected,
      };

      await dispatch(boiapproveex(body));
      hideAdminLoading();

    }
    else {
      setOpenDepAssign(true);
    }

  };



  const forceDocStatus = async (isApprove) => {
    const message = isApprove ? 'approve' : 'reject';

    if (!window.confirm(`Do you want to ${message}?`)) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
      isApprove: isApprove,
    };

    await dispatch(forceApprove(body));
    hideAdminLoading();
  };

  const otherApprove = async () => {

    if (!window.confirm("Do you want to approve?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(otherApproveDoc(body));
    hideAdminLoading();

  }

  const boiUndoDoc = async () => {
    if (!window.confirm("Do you want to undo?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(undoDoc(body));
    hideAdminLoading();
  }

  const otherUndoDoc = async () => {
    if (!window.confirm("Do you want to undo?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(otherUndo(body));
    hideAdminLoading();
  }


  const staffBOIApproveDoc = async () => {

    setOpenStaffApprove(true);


    // if (!window.confirm("Do you want to approve?")) {
    //   return;
    // }
    // showAdminLoading();
    // const body = {
    //   draftId: draftIdSelected,
    // };

    // await dispatch(staffBOIApprove(body));
    // hideAdminLoading();
  }



  const rejectDocument = async () => {
    if (!window.confirm("Do you want to reject?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(rejectDoc(body));
    hideAdminLoading();
  }

  const consultSelect = async () => {
    showAdminLoading();
    const body = {
      draftId: draftIdSelected
    };
    dispatch(clearConsults());
    await dispatch(superaccessList(body))


    setEmpRoleSelected([3])
    setOpenSupervisor(true);
    hideAdminLoading();
  }

  const requestDoc = async (docs) => {
    showAdminLoading();

    const detail = docs.map(x => {
      return {
        reqDetDocId: null,
        configDocumentRequiredID: x.configDocumentRequiredID,
        remark: x.remark,
        status: RequestDocStatus.Request,
      }
    })
    const body = {
      reqDocId: null,
      reqDate: format(new Date(), "yyyy-MM-dd"),
      draftId: draftIdSelected,
      remark: null,
      status: RequestDocStatus.Request,
      detail: detail
    }
    await dispatch(requestDocuments(body));
    hideAdminLoading();
  }

  const departmentApprove = () => {
    const depapprove = configApprveSmartFrom?.find(x => x.departmentId === profile.departmentId);
    return depapprove;
  }


  return (
    <div
      style={{
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
      }}
    >


      <DepsApprove open={openDepApprove} onClose={() => {
        setOpenDepApprove(false);
      }} />


      <DepsAssignDialog open={openDepAssign} onClose={async (departments) => {
        if (departments) {
          showAdminLoading();
          const body = {
            draftId: draftIdSelected,
            isManager: true,
            department: departments.map(x => ({ departmentId: x })),
          };

          await dispatch(approveDoc(body));
          hideAdminLoading();
        }
        setOpenDepAssign(false);

      }} />

      <EmployeeListDialog roles={empRoleSelected} open={open} onClose={async (emp) => {
        if (emp) {

          if (!window.confirm("Do you want to transfer?")) {
            return;
          }

          showAdminLoading();
          const body = {
            draftId: draftIdSelected,
            departmentId: emp.departmentId,
            assignID: emp.empId,
            remark: null,
          };
          await dispatch(reassignDoc(body));
          hideAdminLoading();
        }
        setOpen(false);
      }} />

      <StaffBOIApproveDialogs open={openStaffApprove}
        onClose={async (data) => {

          console.log(data);
          if (data) {
            if (!window.confirm("Do you want to approve?")) {
              return;
            }
            showAdminLoading();
            const body = {
              draftId: draftIdSelected,
              remark: data?.remark,
              visaValidDate: data?.visaValidaDate
            };

            await dispatch(staffBOIApprove(body));
            hideAdminLoading();
            setOpenStaffApprove(false);
          }
          else {
            setOpenStaffApprove(false);
          }


        }} />
      <SupervisorListDialog roles={empRoleSelected} open={openSupervisor}

        onRemove={async (body) => {
          if (body) {
            showAdminLoading();
            await dispatch(superaccessremove(body));
            const _body = {
              draftId: draftIdSelected
            };
            dispatch(clearConsults());
            await dispatch(superaccessList(_body))

            hideAdminLoading();
          }
        }}
        onClose={async (body) => {
          if (body) {
            if (!window.confirm("Do you want to consult?")) {
              return;
            }
            showAdminLoading();
            const _body = {
              draftId: draftIdSelected,
              approveID: body.emp.empId,
              remark: body.remark
            };

            await dispatch(consultDoc(_body));

            dispatch(clearConsults());
            await dispatch(superaccessList({ draftId: draftIdSelected }));

            hideAdminLoading();
            setOpenSupervisor(false);
          }
          else {
            setOpenSupervisor(false);
          }


        }} />


      <RequestLogs open={openReqLogs} onClose={() => {
        setOpenReqLogs(false);
      }} />

      <RequestDocs open={openReqDocs} onClose={async (docs) => {
        setOpenReqDocs(false);
        if (docs) {
          await requestDoc(docs);
        }
      }} />


      {
        /* #region Request Additional Information   */
        departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc &&
        <div className={classes.wrapRequestDocPending}>
          Request Additional Information
        </div>
        /* #endregion */
      }



      {
        /* #region Uploading Additional Documents   */
        departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc &&
        <div className={classes.wrapRequestDocPending}>
          Uploading Additional Documents
        </div>
        /* #endregion */
      }


      {
        /* #region  Processing ส่งเรื่องไปที่หน่วยงานอื่น */
        profile.departmentId === boiDepartmentId
        // && statusProcessId === STATUS_PROCESS.Processing
        && departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing
        &&
        <div style={{ fontSize: "16px", color: "dimgray" }}>
          Processing {configApprveSmartFrom
            .filter(x => x.statusProcessId === STATUS_PROCESS.Processing || x.statusProcessId === STATUS_PROCESS.Approved || x.statusProcessId === STATUS_PROCESS.Rejected)
            .length} / {configApprveSmartFrom.length}
        </div>
        /* #endregion */
      }

      {
        /* #region  กรณี Other Dep อนุมัติ */
        profile.departmentId !== boiDepartmentId &&
        statusProcessId !== STATUS_PROCESS.FinalApproved &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Approved &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
         Pre Approved
        </div>
        /* #endregion */
      }


      {
        /* #region  กรณี Other Dep ยกเลิก */
        profile.departmentId !== boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.Rejected &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Rejected
        </div>
        /* #endregion */
      }

      {
        /* #region  กรณี BOI ยกเลิก */
        profile.departmentId === boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.Rejected &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Rejected
        </div>
        /* #endregion */
      }

      {
        /* #region  Final Reviewing */
        statusProcessId === STATUS_PROCESS.Approved &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          BOI Pre Approved
        </div>
        /* #endregion */
      }


      {
        /* #region  Final Reviewing */
        statusProcessId === STATUS_PROCESS.FinalReviewing &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Final Reviewing
        </div>
        /* #endregion */
      }

      {
        /* #region  Final Approved */
        statusProcessId === STATUS_PROCESS.FinalApproved &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Final Approved
        </div>
        /* #endregion */
      }

      {
        /* #region  Final Rejected */
        statusProcessId === STATUS_PROCESS.FinalRejected &&
        <div style={{ fontSize: "16px", color: "#F53C56" }}>
          Final Rejected
        </div>
        /* #endregion */
      }

      {
        /* #region  Visa Issuance */
        statusProcessId === STATUS_PROCESS.VisaIssuance &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Visa Issuance
        </div>
        /* #endregion */
      }

      {
        /* #region  Visa Received */
        statusProcessId === STATUS_PROCESS.VisaReceived &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Visa Received
        </div>
        /* #endregion */
      }

      {
        /* #region  Complete */
        statusProcessId === STATUS_PROCESS.Complete &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Complete
        </div>
        /* #endregion */
      }

      {
        /* #region  SentManager */
        departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager &&
        profile?.roleId === RoleId.Staff &&
        <div style={{ fontSize: "16px", color: "#2DCE98" }}>
          Waiting for supervisor
        </div>
        /* #endregion */
      }



      {/* // Staff BOI  */}
      {
        isBOI &&  // เป็น Admin ของ BOI  
        profile?.userID === staffID &&   // ไดัรับมอบหมายในเอกสารนั้น
        profile?.roleId === RoleId.Staff && // role = staff
        <>

          {
            /* #region  Sent to other dep */
            (statusProcessId === STATUS_PROCESS.Pending ||
              (departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc ||
                statusProcessId === STATUS_PROCESS.Pending)) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await staffBOIApproveDoc();
              }}
            >
              Approve
            </ColorButton>
            /* #endregion */
          }
          {
            /* #region  Sent to other dep */
            // (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
            //   departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            // <ColorButton
            //   style={{ height: 40, width: 125, marginLeft: 20 }}
            //   variant="contained"
            //   color="success"
            //   onClick={async () => {
            //     await boiApproveDoc();
            //   }}
            // >
            //   Sent
            // </ColorButton>
            /* #endregion */
          }


          {
            /* #region  Reject (No other dep approve,reject) */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  Undo after sent,reject */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected) &&
            configApprveSmartFrom.filter(x => x.departmentId !== boiDepartmentId && x.statusProcessId != STATUS_PROCESS.Pending).length === 0
            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await boiUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }



          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {
            /* #region  Consult (Send Manager) */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {

                consultSelect();
              }}
            >
              Consult
            </ColorButton>
            /* #endregion */
          }

          {
            /* #region  ขอเอกสารเพิ่มเติม */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
            /* #endregion */
          }

        </>
      }

      {/* // BOI Supervisor */}
      {
        isBOI  // เป็น Admin ของ BOI  
        && profile?.roleId === RoleId.Supervisor
        && consults.find(x => x.empId === profile?.userID)
        &&
        <>
          {
            /* #region สามารถ sent ไปหน่วยงานอื่นได้ หลังจาก staff sent manager  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await staffBOIApproveDoc();
              }}
            >
              Sent
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region สามารถ reject ได้ หลังจาก staff sent manager  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  สามารถยกเลิก การอนุมัติก่อนหน้า (Approve, Reject) กรณีที่  ยังไม่มีหน่วยไหน approve, reject */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing) &&  // จะต้องเป็นสถานะ (Approve, Reject)
            configApprveSmartFrom.filter(x => x.departmentId !== boiDepartmentId && x.statusProcessId != STATUS_PROCESS.Pending).length === 0 // จะต้องไม่มีหน่วยงานไหน approve 
            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await boiUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }


          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest) && 
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}

          {
            /* #region มอบหมายงานให้คนอื่น  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
            /* #endregion */
          }


          {
            // ขอเอกสารเพิ่มเติม
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&   //  status เป็น pending || sent manager
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
          }



        </>
      }

      {
        /* #region Request Additional Information   */
        statusProcessId === STATUS_PROCESS.Complete &&
        docDetail?.visaRequestID === "f4e46279-2f64-4428-a7ea-9062b9baf334" &&
        <ColorButton
          style={{ height: 40, width: 150, marginLeft: 20 }}
          variant="contained"
          color="primary"
          onClick={async () => {

            showAdminLoading();
            try {
              const body = {
                draftId: draftIdSelected
              }
              const blob = await AllDocumentsService.downloadCooperation(body)

              const blobFile = new File([blob], `${docDetail?.smartNo}.pdf`, {
                type: mime.getType('.pdf'),
              });

              window.open(
                URL.createObjectURL(blobFile, `${docDetail?.smartNo}.pdf`),
                "_blank"
              );

            } catch (error) {

              console.error(error);
              alert('Something Wrong.')
            }

            hideAdminLoading();
          }}
        >
          Download Cooperation
        </ColorButton>
        /* #endregion */
      }




      {/* // BOI Director */}
      {
        isBOI  // เป็น Admin ของ BOI  
        && profile?.roleId === RoleId.Director
        &&
        <>
          {
            /* #region  Director BOI Approve */
            (statusProcessId === STATUS_PROCESS.Approved) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await boiApproveDoc();
              }}
            >
              Sent
            </ColorButton>
            /* #endregion */
          }


          {
            // สามารถยกเลิกใบคำร้อง
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance) &&   //  status เป็น pending || sent manager
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
          }


          {
            /* #region สามารถยกเลิก การอนุมัติก่อนหน้า (Approve, Reject) กรณีที่ยังไม่มีหน่วยไหน approve, reject  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing) &&
            configApprveSmartFrom.filter(x => x.departmentId !== boiDepartmentId && x.statusProcessId != STATUS_PROCESS.Pending).length === 0 // จะต้องไม่มีหน่วยงานไหน approve 
            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await boiUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }


          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest) &&   //  status เป็น pending || sent manager
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {

                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}


          {
            // มอบหมายงานให้คนอื่น
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager) &&   //  status เป็น pending || sent manager
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
          }


          {
            // ขอเอกสารเพิ่มเติม
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&   //  status เป็น pending || sent manager
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"

              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
          }


          {
            // Force Approve
            statusProcessId === STATUS_PROCESS.FinalReviewing
            &&
            <ColorButton
              style={{ height: 40, marginLeft: 20 }}
              variant="contained"

              color="success"
              onClick={async () => {
                forceDocStatus(true);
              }}
            >
              Force Approve
            </ColorButton>
          }


          {
            // Force Reject
            statusProcessId === STATUS_PROCESS.FinalReviewing
            &&
            <ColorButton
              style={{ height: 40, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                forceDocStatus(false);
              }}
            >
              Force Reject
            </ColorButton>
          }
        </>
      }



      {/* // Staff OtherDep  */}
      {
        isOther &&  // เป็น Admin ของ BOI  
        profile?.roleId === RoleId.Staff &&
        departmentApprove()?.departmentId === profile.departmentId &&
        departmentApprove()?.empId === profile.userID &&

        <>
          {
            /* #region หน่วยงานอื่นอนุมัติ  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending &&
              statusProcessId !== STATUS_PROCESS.FinalRejected) &&

            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await otherApprove();
              }}
            >
              Approve
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  other dep ยกเลิกใบคำร้อง */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending &&
              statusProcessId !== STATUS_PROCESS.FinalRejected) &&

            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  other dep undo (approved, rejected) */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Approved ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected) &&
            statusProcessId === STATUS_PROCESS.Processing

            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await otherUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }


          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {
            /* #region other dep ส่งเรื่องไปยัง Manager, Director */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            statusProcessId !== STATUS_PROCESS.FinalRejected
            &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
            /* #endregion */
          }
          {/* {
            // มอบหมายงานให้คนอื่น
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest)
            &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
          } */}


          {
            /* #region other dep ขอเอกสารเพิ่มเติม  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            (statusProcessId === STATUS_PROCESS.Processing || statusProcessId === STATUS_PROCESS.RequestAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
            /* #endregion */
          }
        </>
      }


      {/* // Supervisor OtherDep  */}
      {
        isOther &&  // เป็น Admin ของ BOI  
        profile?.roleId === RoleId.Supervisor &&
        consults.find(x => x.empId === profile?.userID) &&
        departmentApprove()?.departmentId === profile.departmentId &&
        <>
          {
            /* #region other dep อนุมัติใบคำขอ  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending) &&
            statusProcessId !== STATUS_PROCESS.FinalRejected &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await otherApprove();
              }}
            >
              Approve
            </ColorButton>
            /* #endregion */
          }


          {

            /* #region other dep  Reject ใบคำขอ */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending) &&
            statusProcessId !== STATUS_PROCESS.FinalRejected &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  Other dep undo */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Approved ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected) &&
            statusProcessId === STATUS_PROCESS.Processing
            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await otherUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }


          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {/* {

            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
  
          } */}
          {
            // มอบหมายงานให้คนอื่น
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager) &&
            statusProcessId === STATUS_PROCESS.Processing &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
          }


          {
            // ขอเอกสารเพิ่มเติม
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            (statusProcessId === STATUS_PROCESS.Processing || statusProcessId === STATUS_PROCESS.RequestAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
          }

        </>
      }


      {/* // Director OtherDep  */}
      {
        isOther &&  // เป็น Admin ของ BOI  
        profile?.roleId === RoleId.Director &&
        departmentApprove()?.departmentId === profile.departmentId &&
        <>

          {

            /* #region  Director other dep approve */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending
            ) &&
            statusProcessId !== STATUS_PROCESS.FinalRejected &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await otherApprove();
              }}
            >
              Approve
            </ColorButton>
            /* #endregion */
          }

          {

            /* #region Director other dep reject  */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending) &&
            statusProcessId !== STATUS_PROCESS.FinalRejected &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await rejectDocument();
              }}
            >
              Reject
            </ColorButton>
            /* #endregion */
          }


          {
            /* #region  Director other dep  undo */
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Approved ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected) &&
            statusProcessId === STATUS_PROCESS.Processing
            &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="error"
              onClick={async () => {
                await otherUndoDoc();
              }}
            >
              Undo
            </ColorButton>
            /* #endregion */
          }


          <div style={{
            height: "40px", width: "2px", backgroundColor: "lightgray", marginLeft: "15px", marginRight: "15px"
          }}>

          </div>

          {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Sent) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}
          {
            // มอบหมายงานให้คนอื่น
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc) &&
            statusProcessId === STATUS_PROCESS.Processing &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
          }


          {
            // ขอเอกสารเพิ่มเติม
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequestAddDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            (statusProcessId === STATUS_PROCESS.Processing || statusProcessId === STATUS_PROCESS.RequestAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setOpenReqDocs(true);
              }}
            >
              Request
            </ColorButton>
          }

        </>
      }

      <MoreVertIcon className={classes.buttonStatusDetail} onClick={(event) => {
        setAnchorEl(event.currentTarget);
      }} />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {
          profile?.departmentId === boiDepartmentId &&
          <MenuItem onClick={async () => {

            setAnchorEl(null);
            setOpenDepApprove(true);

          }}>Deps Approve</MenuItem>
        }
        <MenuItem onClick={async () => {
          await dispatch(docLogs({ draftId: draftIdSelected }))
          setAnchorEl(null);
          setOpenReqLogs(true);
        }}>Logs</MenuItem>


        {
          statusProcessId === STATUS_PROCESS.Complete &&
          <MenuItem onClick={async () => {
            const fileFullName = `${draftIdSelected}.pdf`;
            const blob = await ReportService.getResultSmartfromDetail({
              draftId: draftIdSelected,
            });

            const blobFile = new File([blob], fileFullName, {
              type: mime.getType(".pdf"),
            });

            window.open(URL.createObjectURL(blobFile), "_blank");
          }}>Download</MenuItem>
        }



      </Menu>
    </div >
  );
}


function StaffBOIApproveDialogs(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const { configApprveSmartFrom, detial: docDetail } = useSelector(
    (state) => state.allDocuments.detail
  );


  let minDate = new Date();
  let maxDate = new Date();

  if (docDetail?.smartserviceId === M24_CONFIG_DOC.COC.SMART_SERVICE_ID) {
    maxDate.setFullYear(maxDate.getFullYear() + 1);

  }
  else {
    maxDate.setMonth(maxDate.getMonth() + 6);
  }


  const handleClose = () => {
    onClose();
  };



  const dispatch = useDispatch();
  const validationSchema = yup.object({

  });


  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      remark: '',
      visaValidaDate: format(new Date(), "yyyy-MM-dd")
    },
    onSubmit: async (values) => {
      formik.setFieldValue('remark', null);
      onClose({ remark: values.remark, visaValidaDate: format(new Date(formik.values?.visaValidaDate), "yyyy-MM-dd") });
    },
  });



  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  console.log(minDate);
  console.log(maxDate);
  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>Note to director</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl} style={{ marginTop: 15 }}>
                <InputLabel className={classes.d2title}>Visa Valid Date</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    minDate={minDate}
                    maxDate={maxDate}
                    views={["year", "month", "date"]}
                    name={`visaValidaDate`}
                    value={
                      get(formik.values, `visaValidaDate`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `visaValidaDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                  // error={isError(`visaValidaDate`)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl} style={{ marginTop: 15 }}>
                <InputLabel className={classes.d2title}>Note</InputLabel>
              </Grid>

              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField variant="outlined"
                    name={`remark`}
                    value={formik.values.remark}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`remark`, formik)}
                    helperText={getErrorMessage(
                      `remark`,
                      formik
                    )}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}


function SupervisorListDialog(props) {
  const classes = useStyles();
  const { onClose, open, roles, onRemove } = props;
  const { profile } = useSelector(
    (state) => state.user
  );


  const { consults } = useSelector(
    (state) => state.allDocuments
  );


  const handleClose = () => {
    onClose();
  };

  const employees = useSelector((state) => {
    return state.employee.list.filter(x => roles.indexOf(x.roleLevel) > -1 && x.departmentId === profile.departmentId)
  });


  const dispatch = useDispatch();
  const validationSchema = yup.object({
    empId: yup.string().ensure().required("Employee is required.")
  });


  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empId: null,
      remark: ''
    },
    onSubmit: async (values) => {
      const emp = employees.find(x => x.empId === values.empId);
      formik.setFieldValue('remark', null);
      onClose({ emp: emp, remark: values.remark });
    },
  });



  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);




  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>Consult</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>

                {
                  consults.length > 0 &&
                  <>
                    <div style={{ 'color': '#8898aa', marginBottom: 10, fontSize: "16px" }}>
                      Consult List
                    </div>
                  </>
                }

                {
                  consults.filter(x => x.departmentId === profile.departmentId).map((c, index) => (
                    <>
                      <div className={classes.superwrapSupervisorList}>
                        <div key={c.docAccID}>
                          {index + 1}. {c.empFirstname} {c.empLastname}
                        </div>
                        <div>
                          <CloseIcon className={classes.superremove} onClick={async () => {
                            if (!window.confirm("Do you want to remove this consultant?")) {
                              return;
                            }

                            const body = {
                              docAccID: c.docAccID,
                              status: false
                            };
                            onRemove(body)

                          }} />
                        </div>
                      </div>
                    </>
                  ))
                }

              </Grid>

              {
                consults.length > 0 &&
                <hr />
              }

              <Grid item xs={12} md={12} className={classes.warpFormControl} style={{ marginTop: 15 }}>
                <InputLabel className={classes.d2title}>Supervisor</InputLabel>
              </Grid>




              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empId"
                    className={classes.root}
                    value={formik.values.empId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("empId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .filter(x => consults.map(c => c.empId).indexOf(x.empId) === -1)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem
                          key={p.empId}
                          value={p.empId}
                        >
                          {p.employeeFistName}    {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    error={isError("empId", formik)}
                  >
                    {getErrorMessage(
                      "empId",
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl} style={{ marginTop: 15 }}>
                <InputLabel className={classes.d2title}>Remark</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField variant="outlined"
                    name={`remark`}
                    value={formik.values.remark}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`remark`, formik)}
                    helperText={getErrorMessage(
                      `remark`,
                      formik
                    )}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}

function EmployeeListDialog(props) {
  const classes = useStyles();
  const { onClose, open, roles } = props;



  const { profile } = useSelector(
    (state) => state.user
  );

  const handleClose = () => {
    onClose();
  };

  const employees = useSelector((state) => {
    return state.employee.list.filter(x => roles.indexOf(x.roleLevel) > -1 && x.departmentId === profile.departmentId)
  });


  const validationSchema = yup.object({
    empId: yup.string().required("Employee is required.")
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });


  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empId: null,
    },
    onSubmit: async (values) => {
      const emp = employees.find(x => x.empId === values.empId);
      onClose(emp);
    },
  });



  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);



  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>เลือกพนักงาน</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>พนักงาน</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empId"
                    className={classes.root}
                    value={formik.values.empId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("empId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem
                          key={p.empId}
                          value={p.empId}
                        >
                          {p.employeeFistName}    {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    error={isError("empId", formik)}
                  >
                    {getErrorMessage(
                      "empId",
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}

function DepsAssignDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const departmentData = get(masterData, "department", []);
  const { configApprveSmartFrom, smartserviceId } = useSelector(
    (state) => state.allDocuments.detail
  );
  const [departments, setDepartments] = useState([])


  useEffect(async () => {
    if (departmentData && smartserviceId) {
      const resConfigDepartments = await ConfigSmartServiceService.getConfigSmartService({ smartServiceId: smartserviceId });

      if (resConfigDepartments.status) {
        const configDepartments = resConfigDepartments.results;
        const departmentsRaw = departmentData.filter(x => x.departmentId !== boiDepartmentId).map(x => {
          return { ...x, checked: configDepartments?.find(x1 => x.departmentId === x1.departmentId) }
        })
        setDepartments(departmentsRaw);
      }
    }
  }, [departmentData, smartserviceId]);



  useEffect(async () => {

    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          smartservice: true,
          department: true,
        })
      );
    }
    mergedFetchData();


  }, []);


  const handleClose = () => {
    onClose();
  };




  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>หน่วยงานที่ตรวจสอบ</DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {
            departments?.map((row, index) => (
              <div key={row.departmentId} className={classes.rowPopItem}>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      checked={row.checked}
                      onClick={(event) => {
                        const _deps = departments.map((item, index2) => (index === index2) ? { ...item, checked: event.target.checked } : item)
                        setDepartments(_deps);
                      }}
                    />
                  }
                  label={row.departmentName}
                />

              </div>
            ))
          }
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" color="primary" onClick={() => {
                  const departmentIds = departments.filter(x => x.checked).map(x => x.departmentId)
                  onClose(departmentIds);
                }} className={classes.buttonDialogSave}>
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>

      </DialogContent>
    </Dialog >
  );
}

function DepsApprove(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  useEffect(() => {


  }, []);

  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = () => {
    onClose();
  };

  const { configApprveSmartFrom } = useSelector(
    (state) => state.allDocuments.detail
  );



  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>หน่วยงานที่ตรวจสอบ</DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {
            configApprveSmartFrom?.map((row, index) => (
              <div key={row.departmentId} className={classes.rowPopItem}>
                {
                  (row.statusProcessId === STATUS_PROCESS.Sent ||
                    row.statusProcessId === STATUS_PROCESS.Complete ||
                    row.statusProcessId === STATUS_PROCESS.Approve) &&
                  <Fragment>
                    <div className={classes.iconPop} style={{ backgroundColor: "#2DCE98" }}>
                      <CheckIcon >
                      </CheckIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                }
                {
                  // (row.statusProcessId !== STATUS_PROCESS.Sent &&
                  //   row.statusProcessId !== STATUS_PROCESS.Complete &&
                  //   row.statusProcessId !== STATUS_PROCESS.Approve &&
                  //   row.statusProcessId !== STATUS_PROCESS.Reject
                  // ) &&
                  (row.statusProcessId === STATUS_PROCESS.Pending
                  ) &&
                  <Fragment>
                    <div className={classes.iconPop} style={{ backgroundColor: "#FEB969" }}>
                      <RemoveIcon >
                      </RemoveIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                }

                {
                  (
                    row.statusProcessId === STATUS_PROCESS.Reject
                  ) &&
                  <Fragment>
                    <div className={classes.iconPop} style={{ backgroundColor: "#f53c56" }}>
                      <CloseIcon >
                      </CloseIcon>
                    </div>
                    <span>
                      {row.departmentName} ({row.empFirstName} {row.empLastName})
                    </span>
                  </Fragment>
                }
              </div>
            ))
          }
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>

      </DialogContent>
    </Dialog >
  );
}

function RequestLogs(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const { logs } = useSelector(
    (state) => state.allDocuments
  );


  useEffect(async () => {

  }, [open]);

  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = () => {
    onClose();
  };


  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>ประวัติการทำรายการ</DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {
            logs?.map((row, index) => (
              <div key={row.departmentId} >
                <div className={classes.rowPopItem}>
                  <Fragment>
                    <div style={{
                      width: 150
                    }}>
                      {format(new Date(row.createDate), "yyyy-MM-dd HH:mm")}
                    </div>
                    <span>
                      {row.statusName}
                    </span>

                  </Fragment>

                </div>

                <div className={classes.rowPopItem}>
                  <Fragment>
                    <div style={{
                      width: 150
                    }}>

                    </div>
                    <div style={{ color: "darkgray", fontSize: "11px" }}>
                      {row.departmentName}
                    </div>


                  </Fragment>

                </div>


                {
                  row.remark &&
                  <div className={classes.rowPopItem}>
                    <Fragment>
                      <div style={{
                        width: 150
                      }}>

                      </div>
                      <div style={{ color: "dimgray", fontSize: "0.85em", fontWeight: "400" }}>
                        Remark: {row.remark}
                      </div>

                    </Fragment>

                  </div>

                }

              </div>

            ))
          }
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>

      </DialogContent>
    </Dialog >
  );
}

function RequestDocs(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const { data } = useSelector(
    (state) => state.visaForm.documentRequired
  );


  const [requiredList, setRequiredList] = useState(data);

  useEffect(async () => {
    if (open) {
      setRequiredList(data.map((item) => ({ ...item, checked: false, remark: '' })));
      // setRequiredList(data)
    }

  }, [open]);

  const handleListItemClick = () => {
    if (!window.confirm("Do you want to request documents?")) {
      return;
    }
    const requested = requiredList.filter(x => x.checked);
    onClose(requested);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>ขอข้อมูลเพิ่มเติม</DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          <FormGroup>
            {
              requiredList?.map((row, index) => (
                <div className={classes.wrapRequestDoc} key={row.configDocumentRequiredID}>
                  <FormControlLabel
                    style={{ marginBottom: 16, alignItems: 'start' }}
                    control={<Checkbox style={{ padding: '0px 9px' }}
                      checked={row.checked}
                      onChange={(event) => {
                        const _list = requiredList.map((item, index2) => (index === index2) ? { ...item, checked: event.target.checked } : item)
                        setRequiredList(_list);
                      }} />}
                    label={row.documentName} />

                  {
                    row.checked &&
                    <TextField
                      placeholder="ระบุหมายเหตุ"
                      variant="outlined"
                      className={classes.textField}
                      name={row.configDocumentRequiredID}
                      value={row.remark}
                      onChange={(event) => {
                        const _list = requiredList.map((item, index2) => (index === index2) ? { ...item, remark: event.target.value } : item)
                        setRequiredList(_list);
                      }}
                    />
                  }

                </div>

              ))
            }
          </FormGroup>


          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" color="primary" onClick={() => handleListItemClick()} className={classes.buttonDialogSave}>
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>

        </div>

      </DialogContent>
    </Dialog >
  );
}

const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);
